import { render, staticRenderFns } from "./invitation_notification.vue?vue&type=template&id=e4628a06&scoped=true&"
import script from "./invitation_notification.vue?vue&type=script&lang=js&"
export * from "./invitation_notification.vue?vue&type=script&lang=js&"
import style0 from "./invitation_notification.vue?vue&type=style&index=0&id=e4628a06&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4628a06",
  null
  
)

export default component.exports